export { default as AutoFormat } from './AutoFormat';
